import Swiper from 'vendor_components/swiper.min';
import {
    isMobile,
    jsLink,
    jsDots,
    log,
} from 'methods/utils';

function Recommendation() {
    this.initSwiper = function($widget) {
        if (!$widget) {
            return;
        }

        const $swiperContainer = $widget.querySelector('.swiper');

        if (!$swiperContainer) {
            return;
        }

        new Swiper($swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
                prevEl: $widget.querySelector('.js-swiperArrowPrev'),
                nextEl: $widget.querySelector('.js-swiperArrowNext'),
            },
            breakpoints: {
                960: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            },
            on: {
                init: () => $widget.classList.add('RR-widget--active'),
            },
        });
    }

    // получаем рендер с сайта по
    this.siteApi = function($widget, hotelIds = [], type = '', data = {}) {
        let formData = new FormData();
            hotelIds.forEach(id => formData.append('hotel_ids[]', id));

        let isMainPage = location.pathname === '/' ? 1 : 0
            formData.append('is_main_page', isMainPage);

        formData.append('rr_type', type);

        if (typeof data.geo_id != 'undefined') {
            formData.append('geo_id', data.geo_id);
        }

        try {
            fetch('/rr/get_hotel_data/', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok' && r.render) {
                    $widget.innerHTML = r.render;

                    this.initSwiper($widget);

                    jsDots();
                }
            });
        } catch(error) {
            log('Возникла проблема с вашим fetch запросом: ', error.message);
        }
    }

    // получаем данные с api rr
    this.rrApi = function($widget, data) {
        const categoryIds = [];
        if (data?.geo_id) {
            categoryIds.push(data.geo_id);
        }

        switch(data.type) {
            case 'personal':
                this.retailrocket.recommendation.forCategories(
                    this.retailrocket.api.getPartnerId(),
                    categoryIds,
                    'personal',
                    {/* vendor: 'Общие' */},
                    (items) => {
                        if (items.length === 0) {
                            return false;
                        }

                        items.sort((a, b) => {
                            if (a.Params.priority === b.Params.priority) {
                                return b.Weight - a.Weight;
                            }

                            return b.Params.priority - a.Params.priority;
                        });

                        items.forEach(item => log(item.Params.priority, item.Weight));

                        let hotelIds = items.map(item => item.ItemId);

                        this.siteApi($widget, hotelIds, 'personal', data);
                    }
                );
                break;
            case 'popular':
                this.retailrocket.recommendation.forCategories(
                    this.retailrocket.api.getPartnerId(),
                    categoryIds,
                    'popular',
                    {/* vendor: 'Общие' */},
                    (items) => {
                        if (items.length === 0) {
                            return false;
                        }

                        items.sort((a, b) => {
                            if (a.Params.priority === b.Params.priority) {
                                return b.Weight - a.Weight;
                            }

                            return b.Params.priority - a.Params.priority;
                        });

                        let hotelIds = items.map(item => item.ItemId);

                        this.siteApi($widget, hotelIds, 'popular', data);
                    }
                );
                break;
        }
    }

    // api rr готово
    this.rrApiOnReady = function() {
        this._$widgets = document.getElementsByClassName('RR-widget');

        [...this._$widgets].forEach($widget => {
            let data = {
                type: $widget.dataset.type || '',
                geo_id: this.getGeoId(),
            }

            this.rrApi($widget, data);
        });
    }

    this.getGeoId = function () {
        return window.pageData?.['retail-rocket']?.['geo-id'];
    }

    this.init = function() {
        (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
            this.retailrocket = retailrocket;
            // this.rrApiOnReady();
        });
    }
    this.init();
}

export default Recommendation;
